import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";

import styles from '../styles.module.scss';
import { Label, DropSelect, DatePiker } from "modules/primitives";
import { setActualScoreCardFilters } from "modules/reporting/fordReports/actualScorecard/store/actualScoreCard.actions";
import { projectMetricFilters } from "modules/reporting/fordReports/utils";

const FordProjectMetricsFilter = ({ handleFilterUpdate }) => {
  const dispatch = useDispatch();

  const {
    fordDashboardReducer: { actualScoreCardReducer }
  } = useSelector((state) => state);

  const [fieldValues, setFieldValues] = useState({});

  useEffect(() => {
    setFieldValues(actualScoreCardReducer.filters?.projectMetrics || {});
  }, [actualScoreCardReducer.filters?.projectMetrics]);

  const updateFilters = useCallback((newValues) => {
    dispatch(setActualScoreCardFilters({
      ...actualScoreCardReducer.filters,
      projectMetrics: newValues
    }));

    handleFilterUpdate({projectMetrics: newValues}, actualScoreCardReducer.tableData?.expandedKey);
  }, [actualScoreCardReducer]);

  const handleFieldValueChange = (value, prop) => {
    const newValues = {
      ...fieldValues,
      [prop]: value.obj,
    };

    setFieldValues(newValues);
    updateFilters(newValues);
  };

  const handleDateChange = (value, prop) => {
    const newValues = {
      ...fieldValues,
      [prop]: value,
    };

    setFieldValues(newValues);
    updateFilters(newValues);
  }

  return (
    projectMetricFilters.map(filter => (
      <div key={filter.id} className={classNames(styles.filter, 'mb-3')}>
        <Label>{filter.name}</Label>
        {
          filter.datePicker ? (
            <DatePiker
              name={filter.id}
              value={fieldValues[filter.id] || ''}
              onChange={(e) => handleDateChange(e, filter.id)}
              showTime
              withClear
            />
          ) : (
            <DropSelect
              multi={filter.id === 'next_stage_start_on'}
              values={fieldValues[filter.id] || []}
              onChange={(val) => handleFieldValueChange(val, filter.id)}
              options={filter.options}
              labelField="name"
              valueField="id"
              placeholder={filter.name}
              searchBy="name"
            />
          )
        }
      </div>
    ))
  );
};

export default React.memo(FordProjectMetricsFilter);
